<template>
  <v-select
    class="account-select"
    v-model="selectedAccount"
    :options="accounts"
    label="name"
    :clearable="false"
    placeholder="Select"
  >
    <template slot="selected-option" slot-scope="option">
      <span class="selected-label">{{ option.name }}</span>
    </template>
    <template slot="option" slot-scope="option">
      <span class="option-label">{{ option.name }}</span>
    </template>
  </v-select>
</template>
<script>
export default {
  props: ["data", "field", "accounts"],
  computed: {
    selectedAccount: {
      get() {
        const id = this.data[this.field];
        if (id == null || id === "") return null;
        return (
          this.accounts.find((account) => String(account.id) === String(id)) ||
          null
        );
      },
      set(account) {
        this.$set(this.data, this.field, account ? account.id : null);
      },
    },
  },
};
</script>
<style scoped>
.account-select >>> .vs__dropdown-toggle {
  min-height: 42px;
  background: #111;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
}

.account-select >>> .vs__selected {
  color: #f0e6c8;
  font-weight: 600;
  margin: 0;
}

.selected-label {
  color: #f0e6c8;
  font-weight: 600;
}

.account-select >>> .vs__search,
.account-select >>> .vs__search:focus {
  color: #f0e6c8;
  margin: 0;
}

.account-select >>> .vs__open-indicator,
.account-select >>> .vs__clear {
  fill: #d8c48a;
}

.account-select >>> .vs__dropdown-menu {
  background: #1c1c1c;
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #f0e6c8;
}

.account-select >>> .vs__dropdown-option {
  color: #f0e6c8;
}

.account-select >>> .vs__dropdown-option--highlight {
  background: rgba(231, 181, 52, 0.22);
  color: #f7d56a;
}

.option-label {
  color: #f0e6c8;
  font-weight: 600;
}
</style>
